import React from 'react';
import { Card, Row, Col } from 'antd';
import { useNavigate } from 'react-router';

interface AdminCardProps {
  prefix: string;
  title: string;
  description?: string;
}

const imageStyle: React.CSSProperties = {
  aspectRatio: '1 / 1',
  objectFit: 'cover',
  width: '100%',
};

const ToolCard: React.FC<AdminCardProps> = ({ prefix, title }) => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate(`/${prefix}/list`);
  };

  return (
    <Col span={24} xs={24} sm={12} lg={6}>
      <Card
        style={{ height: '100%', cursor: 'pointer' }}
        cover={<img alt={prefix} src={`/public/images/${prefix}_logo.jpeg`} style={imageStyle} />}
        onClick={onClick}
        hoverable>
        <Row>
          <Col span={24}>
            <Card.Meta title={title} />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export const ToolListPage: React.FC = () => (
  <Row gutter={[16, 16]} style={{ width: '100%', marginTop: '8px' }}>
    <ToolCard prefix="site-visit" title="Site visit" />
  </Row>
);
